import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SeleccionInformesScreen from './screen';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';
import { PeriodosAdapter } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';

export const SeleccionInformesContainer = () => {

	const api = new InformesDetalleAdapter();
	const apiPeriodos = new PeriodosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [año, setAño] = useState<any>(undefined);
	let [periodo, setPeriodo] = useState<any>(undefined);
	let [reunion, setReunion] = useState<any>(undefined);
	let [isLoading, setIsLoading] = useState<boolean>(false);

	let result: any;

	useEffect(()=>{
		getTiposContenido();
	  },[])
	
	const getTiposContenido = async () => {
		try {
			setIsLoading(true);
			result = await apiPeriodos.getTiposContenidoPeriodoAbierto();
			if(result.data && result.data!=="")
			{
				var data = ([ ...result.data ] || []);
				if(data.length > 0){						
					setAño(([ ...result.data ] || [])[0].año);
					setPeriodo(([ ...result.data ] || [])[0].periodo);
					setReunion(([ ...result.data ] || [])[0].reunion);
				}else{
					setAño(undefined);
					setPeriodo(undefined)
					setReunion(undefined);
				}
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
		setIsLoading(false);
	};

	const getDatosInforme = async (data: any) => {
		setIsLoading(true);
		setData([]);
		try {
			result = await api.ListarInformeData(data);
			if(result.data && result.data!==""){
				setData([...result.data] || []);
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		setIsLoading(false);
  	};
	
	const setMostrarOcultarClick = async (pdata: any) => {
		try {
			result = await api.setMostrarOcultarCentro(pdata);
			if(result.data && result.data!==""){
				// console.log('setMostrarOcultarClick',result.data);
				if(result.data){
					// console.log('data GRID', data.filter((x:any) => x.idCentro == pdata.IdCentro && x.idPais == pdata.IdPais)[0].noMostrar);
					if(pdata.IdTipoInforme.substring(0,2) == 'GR'){
						data.filter((x:any) => x.idCentro == pdata.IdCentro).forEach((e:any) => {
							e.noMostrar = pdata.NoMostrar;
						});
					}else{
						data.filter((x:any) => x.idCentro == pdata.IdCentro && x.idPais == pdata.IdPais)[0].noMostrar = pdata.NoMostrar;
					}
					// console.log('data GRID', data.filter((x:any) => x.idCentro == pdata.IdCentro && x.idPais == pdata.IdPais)[0].noMostrar);
					setData([...data]);
					// getDatosInforme({año: data.año, periodo: data.periodo, IdTipoInforme: data.IdTipoInforme, MonedaCorriente: data.MonedaCorriente, moneda: data.moneda, IdCentroDesde: data.IdCentroInforme});
				}
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	}

	const setSubirBajarClick = async (data: any) => {
		try {
			result = await api.setSubirBajarCentro(data);
			if(result.data && result.data!==""){
				// console.log('setMostrarOcultarClick',result.data);
				if(result.data)
					getDatosInforme({año: data.año, periodo: data.periodo, IdTipoInforme: data.IdTipoInforme, MonedaCorriente: data.MonedaCorriente, moneda: data.moneda, IdCentroDesde: data.IdCentroInforme});
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	}

	const setOtroFormatoCentro = async (pdata: any) => {
		try {
			result = await api.setOtroFormatoCentro(pdata);
			if(result.data && result.data!==""){
				// console.log('setMostrarOcultarClick',result.data);
				if(result.data){
					data.filter((x:any) => x.idCentro == pdata.IdCentro && x.idPais == pdata.IdPais)[0].otroFormato = !data.filter((x:any) => x.idCentro == pdata.IdCentro && x.idPais == pdata.IdPais)[0].otroFormato;
					setData([...data]);
					// getDatosInforme({año: data.año, periodo: data.periodo, IdTipoInforme: data.IdTipoInforme, MonedaCorriente: data.MonedaCorriente, moneda: data.moneda, IdCentroDesde: data.IdCentroInforme});
				}
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	}

	const setLabelBottomClick = async(pData: any) => {
		try {
			let reqData = {año: pData.año, periodo: pData.periodo, IdTipoInforme: pData.IdTipoInforme, IdCentroInforme: pData.IdCentroInforme, 
							IdPais: pData.IdPais,labelBottom_cont: (pData.ColName == 'labelBottom_cont' ? pData.Value : null), labelBottom_fact: (pData.ColName == 'labelBottom_fact' ? pData.Value : null), 
							labelBottom_prod: (pData.ColName == 'labelBottom_prod' ? pData.Value : null), labelBottom_apor: (pData.ColName == 'labelBottom_apor' ? pData.Value : null), 
							labelBottom_bdi: (pData.ColName == 'labelBottom_bdi' ? pData.Value : null) };
			
			result = await api.setLabelBottomGrevol(reqData);
			if(result.data && result.data!==""){
				// console.log('setMostrarOcultarClick',result.data);
				if(result.data){
					if(pData.ColName == 'labelBottom_bdi' || pData.ColName == 'labelBottom_apor'){
						data.forEach((x: any) => {
							x[pData.ColName] = pData.Value;
						});
					}else{
						data.forEach((x: any) => {
							if(x.idPais == pData.IdPais) x[pData.ColName] = pData.Value;
						});
					}
					setData([...data]);					
				}
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	}

	const onClearData = async() => {
		setData([]);
	}

	return (
		<>
			<SeleccionInformesScreen data={data} onFilter={getDatosInforme} año={año} periodo={periodo} reunion={reunion} isLoading={isLoading} onMostrarOcultarClick={setMostrarOcultarClick} onSubirBajarClick={setSubirBajarClick} onOtroFormatoClick={setOtroFormatoCentro} onLabelBottomClick={setLabelBottomClick} onClearData={onClearData} />
		</>
	);
};

export default SeleccionInformesContainer;
function exceptionError(exception: { title: string; message: any; code?: undefined; } | { title: string; message: any; code: any; } | undefined) {
	throw new Error('Function not implemented.');
}

function resultError() {
	throw new Error('Function not implemented.');
}

function launchNotification(arg0: { type: string; title: string; message: string; }) {
	throw new Error('Function not implemented.');
}

